<template>
  <div style="height: 100%">
    <div class="info">
      <span class="title">{{ $t('海珠廉洁文化生态园海廉展馆') }}</span>
      <img src="../../assets/images/hlgbanner.png" class="banner" />

      <span class="time">{{ $t('开馆时间：') }}</span>
      <span class="time">{{ $t('每日9：00-12：00;14：00-17:00') }}</span>
      <span class="time">{{ $t('每逢周一闭馆，节假日顺延') }}</span>
      <span class="introduction">{{
        $t(
          '海廉展馆位于湿地二期海珠廉洁文化生态园内，馆内共设置羊城廉吏、清风良言、廉洁海珠、笔墨丹青四个版块以及知识抢答游戏、动漫交互体验、湿地植物全景漫游三个互动区域，为党员干部、群众提供沉浸式的教育和熏陶场所。'
        )
      }}</span>
      <div style="margin-bottom: 25px">
        <p class="text">{{ $t('预约方式：') }}</p>
        <span class="text">{{
          $t(
            '（注：海廉展馆位于海珠湿地公园内，进入馆内需要先购买湿地公园门票再预约进入展馆）'
          )
        }}</span>
        <br />
        <span class="text"
          >{{
            $t(
              '步骤1：购买湿地公园门票——微信公众号“海珠湿地”菜单栏“湿地攻略”点击栏目“湿地门票购买”买票。'
            )
          }}<wx-open-launch-weapp
            appid="wx4aa439606f9477bd"
            path="/pages/code/index?redirect=942f827b10a91bfa"
          >
            <script type="text/wxtag-template">
              {{$t('<style>.buyTick {display: inline;font-size: 3.73333vwoutline: none;background: transparent;border: none;color: #1989fa;padding: 0;margin: 0;}</style><button class=_##_buyTick_##_>点击购票</button>')}}
            </script>
          </wx-open-launch-weapp>
          <!-- <button class="buyTick">点击购票</button> -->
        </span>
        <br />
        <span class="text">{{
          $t(
            '步骤2：预约进入展馆——方式一：微信公众号“海珠湿地”菜单栏“湿地攻略”点击栏目“海廉展馆预约”进行线上入馆预约；方式二：微信公众号“海珠微监察”公众号点击栏目“海廉展馆”进行线上入馆预约；方式三：海廉展馆扫描门口右侧立柱屏幕二维码进行现场入馆预约。'
          )
        }}</span>
      </div>
      <span class="text">{{
        $t(
          '进馆方式：展馆实现访客自助预约签到进馆，访客预约成功后在海廉展馆门口右侧立柱屏幕上点击入馆参观，可选取预约码、刷脸识别、二维码识别任意一种方式，扫描成功后展馆大门即可自动打开。'
        )
      }}</span>
      <div class="btn_box">
        <van-button
          round
          block
          type="info"
          class="agree-btn"
          @click.stop="goApply()"
          >{{ $t('个人预约登记') }}</van-button
        >
        <van-button
          round
          block
          type="info"
          class="agree-btn"
          @click.stop="goGroupApply()"
          >{{ $t('团体预约登记') }}</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getJsApiTicket } from '@/services/api'
import Vue from 'vue'
import wx from 'weixin-js-sdk'
import { Button } from 'vant'
Vue.use(Button)
export default {
  name: 'introduction',
  components: {},
  data() {
    return {}
  },
  methods: {
    goApply() {
      const companyCode = this.$route.query.companyCode
      this.$router.push({
        path: `/visitor/apply/${this.$route.params.companyId}`,
        query: { companyCode: companyCode },
      })
    },
    goGroupApply() {
      const companyCode = this.$route.query.companyCode
      this.$router.push({
        path: `/visitor/group-apply/${this.$route.params.companyId}`,
        query: { companyCode: companyCode },
      })
    },
  },
  computed: {},
  created() {
    const companyId = window.location.host === 'uat.newbest.com.cn' ? 169 : 257
    getJsApiTicket({ companyId, url: window.location.href }).then((res) => {
      //请求后台接口
      wx.config({
        debug: false, //是否开启debug
        appId: res.appId, //你的appid
        timestamp: res.timestamp, //时间戳
        nonceStr: res.noncestr, //随机字符串
        signature: res.signature, //秘钥
        jsApiList: [
          //请求的api接口列表，微信的，详情去看微信官方文档
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'getLocation',
          'openLocation',
          'onMenuShareAppMessage',
          'onMenuShareTimeline',
        ],

        openTagList: ['wx-open-launch-weapp'],
      })
      wx.ready(function () {
        //如果wx.config配置正常，会自动走此处
        console.log('ready执行完毕')
      })
      wx.error(function (res) {
        //如果wx.config配置失败,会走到此处
        console.log('error', res)
      })
    })
  },
}
</script>
<style lang="less" scoped>
.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 14px;
}

.title {
  height: 20px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #474646;
  line-height: 20px;
  margin-top: 14px;
}

.banner {
  width: 350px;
  height: 170px;
  margin-top: 14px;
  margin-bottom: 20px;
}

.time {
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #474646;
}

.introduction {
  margin-top: 20px;
  font-size: 14px;
  line-height: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #474646;
  margin-bottom: 30px;
}

.text {
  font-size: 14px;
  line-height: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #474646;
}

.agree-btn {
  height: 60px;
  width: 150px;

  font-size: 18px;
}

.btn_box {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.buyTick {
  display: inline;
  outline: none;
  background: transparent;
  border: none;
  color: #1989fa;
  padding: 0;
  margin: 0;
}
</style>
